module.exports = __webpack_public_path__ + "img/100-point.61f0d93d.png";